import { ImageIcon } from "lucide-react";

/**
 * Elegant tile component. Renders a real photo when `src` is provided,
 * otherwise an intentional placeholder so designers can drop in images later.
 */
export const Placeholder = ({
  label,
  className = "",
  arch = false,
  testId,
  showIcon = true,
  caption = null,
  src = null,
  alt = "",
  position = "center",
}) => {
  const shape = arch ? "arch" : "rounded-2xl";

  if (src) {
    return (
      <div
        data-testid={testId}
        className={`relative overflow-hidden ${shape} ${className}`}
      >
        <img
          src={src}
          alt={alt || label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-[1.04]"
          style={{ objectPosition: position }}
        />
        {(label || caption) && (
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-transparent" />
        )}
        {(label || caption) && (
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 text-white">
            {label && (
              <div className="text-[10px] uppercase tracking-[0.24em] text-white/80">
                {label}
              </div>
            )}
            {caption && (
              <div className="mt-1 font-serif text-lg md:text-xl leading-snug">
                {caption}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className={`placeholder-box ${shape} relative flex flex-col items-end justify-end p-6 md:p-8 text-[#0a192f] ${className}`}
    >
      {showIcon && (
        <div className="absolute top-5 left-5 inline-flex items-center gap-2 text-[#6b705c]/80">
          <ImageIcon className="h-4 w-4" strokeWidth={1.4} />
          <span className="text-[10px] uppercase tracking-[0.24em]">Image</span>
        </div>
      )}
      <div className="relative z-10 max-w-[80%] text-right">
        <div className="text-xs uppercase tracking-[0.22em] text-[#6b705c]">
          {label}
        </div>
        {caption && (
          <div className="mt-1 font-serif text-lg md:text-xl text-[#0a192f]/80 leading-snug">
            {caption}
          </div>
        )}
      </div>
    </div>
  );
};
